import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/storage';
import 'firebase/compat/firestore';
import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCKvWEdlQLmuVB_DGoQVXdvmuNUaijhxek",
  authDomain: "test-f840f.firebaseapp.com",
  projectId: "test-f840f",
  storageBucket: "test-f840f.appspot.com",
  messagingSenderId: "211370224886",
  appId: "1:211370224886:web:4195927afca346b3d910d7",
  measurementId: "G-XJ6VNHNH7C"
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);

const auth = firebase.auth();
const firestore = firebase.firestore();
const db = firebase.firestore();
const storage = firebase.storage();
// const app = initializeApp(firebaseConfig);
// const auth = getAuth(app);
const provider = new GoogleAuthProvider();

const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, provider);
    return result.user;
  } catch (error) {
    console.error("Error during Google Sign-In:", error);
  }
};


export { auth, firestore, firebase, db, storage, firebaseConfig, signInWithGoogle }; // Export the modules

export default firebase;
